import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getNewsUpdateDetails = (pageSize) => {
  const url = `${API_URLS.newsUpdate}&sort=updatedAt:DESC&pagination[pageSize]=6&pagination[page]=${pageSize}`;
  return axiosClient.get(url);
};

export const getNewsTagDetails = () => {
  const url = API_URLS.newsTags;
  return axiosClient.get(url);
};

export const queryUpdateDetails = (filterName, pageSize) => {
  const url = `${API_URLS.newsQueryApi}${filterName}&sort=updatedAt:DESC&pagination[pageSize]=6&pagination[page]=${pageSize}`;
  return axiosClient.get(url);
};

export const getNewsListDetails = () => {
  const url = API_URLS.newsListingApi;
  return axiosClient.get(url);
};
